<!--
 * Copyright (c) 2023 by Allen_sun email: Allen_sun_js@hotmail.com, All Rights Reserved.
-->
<!--  -->
<template>
  <div>
    <Menu :menuTitle="title" />
    <div class="ranking_wrap">
      <div class="content">
        <div class="details_content">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="学习排行" name="first">
              <Studyranking />
            </el-tab-pane>
            <el-tab-pane label="考试排行" name="second">
              <Examinationranking />
            </el-tab-pane>
            <el-tab-pane label="业绩跟踪" name="third">
              <PerformanceTracking />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/Menu";
import Studyranking from "./componetsRanking/Studyranking.vue";
import Examinationranking from "./componetsRanking/Examinationranking.vue";
import PerformanceTracking from "./componetsRanking/PerformanceTracking.vue";
export default {
  components: {
    Menu,
    Studyranking,
    Examinationranking,
    PerformanceTracking,
  },
  data() {
    return {
      title: "排行榜",
      activeName: "first",
      performaceInfo: {
        flag: false,
      },
    };
  },
  activated() {
    if (
      new Date().getTime() <= new Date(this.$route.query.endGradeTime).getTime()
    ) {
      this.performaceInfo.flag = true;
      this.performaceInfo.endDate = this.$route.query.endGradeTime;
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style lang="scss" scoped>
.ranking_wrap {
  background-color: $white;
  padding-top: 104px;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 80px;
  }
}
/deep/.el-tabs__item {
  padding: 0 30px;
}
/deep/.el-tabs__header {
  margin: 0;
}
/deep/ .el-tab-pane {
  width: 1200px;
  height: auto;
  margin-top: 20px;
}
/deep/ .el-tabs__item {
  font-size: 18px;
  color: $font_color_grey_3;
}

/deep/ .el-tabs__item.is-active {
  color: $theme_color;
}
/deep/ .el-tabs__nav-wrap::after {
  display: none;
}

/deep/ .el-tabs__active-bar {
  display: none;
}
</style>
